export const CLIENT_VERSION = "8b28f6179f3f1874299e047cb8a3f323b57630b7";
